import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();

  const navLinks = [
    { to: "/", label: t("nav.home") },
    { to: "/about", label: t("nav.about") },
    { to: "/vendors", label: t("nav.vendors") },
    { to: "/riders", label: t("nav.riders") },
    { to: "/waitlist", label: t("nav.waitlist") },
  ];

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/117133a6-3dd8-43d6-a464-18afa34af3c0/9887b7f2-ccf6-45c1-a630-cdac611c7766_compressed_mayouk-logo.webp"
                alt="Mayouk"
                className="h-10 w-10 object-contain"
              />
              <span className="font-heading text-xl font-bold text-background-50">
                Mayouk
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              {t("footer.about_text")}
            </p>
            <p className="text-sm text-background-400 italic">
              {t("footer.tagline")}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
              {t("footer.navigation")}
            </h4>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
              {t("footer.contact")}
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-accent-400 text-sm"></i>
                </div>
                <a
                  href="tel:+237681172545"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  rel="nofollow"
                >
                  {t("waitlist.phone_value")}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-accent-400 text-sm"></i>
                </div>
                <a
                  href="https://wa.me/237681172545"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                >
                  {t("waitlist.whatsapp_value")}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-accent-400 text-sm"></i>
                </div>
                <a
                  href="mailto:info@mayouk.com"
                  className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                  rel="nofollow"
                >
                  {t("waitlist.email_value")}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-accent-400 text-sm"></i>
                </div>
                <span className="text-sm text-background-300">
                  {t("waitlist.location_value")}
                </span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
              {t("footer.social")}
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://wa.me/237681172545"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="flex items-center gap-2 text-sm text-background-300 hover:text-accent-400 transition-colors"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-whatsapp-line text-accent-400"></i>
                  </div>
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-foreground-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-400">
            &copy; {t("footer.copyright")}
          </p>
          <div className="flex items-center gap-4 text-sm text-background-400">
            <a href="#" className="hover:text-background-200 transition-colors">
              {t("footer.privacy")}
            </a>
            <a href="#" className="hover:text-background-200 transition-colors">
              {t("footer.terms")}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}